export default "__VITE_ASSET__7cb27769__"